module.exports = __webpack_public_path__ + "static/self-help-tools@2x-f6743b4982c87cb685ad38dffed6e7e9.png";